import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito diagnóstico médico para seguir el sistema?',
    a: 'No. Está diseñado para el estreñimiento funcional crónico: mujeres que van al médico, les dicen que "todo está bien" y siguen igual. Si no hay causa orgánica, este sistema es para vos. Ante señales de alarma (sangre, pérdida de peso, dolor severo), consultá al médico primero.'
  }, {
    q: '¿Tengo que comprar productos importados o caros?',
    a: 'No. Todo fue diseñado para la feria de barrio, la farmacia y la dietética argentina. El Bono 2 incluye el directorio exacto de marcas argentinas con precios reales. Nada importado ni caro.'
  }, {
    q: '¿Cuánto tarda en funcionar?',
    a: 'Los primeros cambios se notan entre el Día 2 y el Día 5. Al Día 21 la mayoría tiene un sistema estabilizado. El Bono 4 mide el progreso exacto día a día.'
  }, {
    q: '¿Es compatible con el medicamento que tomo?',
    a: 'El sistema es nutricional y de estilo de vida. La única interacción a cuidar es el Magnesio con medicación tiroidea o antibióticos (el Bono 2 lo explica). No modifica ninguna medicación prescrita.'
  }, {
    q: '¿El producto es 100% digital?',
    a: 'Sí. Recibís acceso inmediato por email apenas se confirma el pago. PDF de alta calidad para celular, tablet, computadora o imprimir. Acceso de por vida: lo descargás una vez y es tuyo para siempre.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 21 días sin preguntas. Si no es lo que esperabas, devolvemos el 100% del pago sin formularios ni drama. La tasa de devoluciones es menor al 1%.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-brand-black" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <div className="max-w-3xl mx-auto" data-id="element-95">
          <div className="text-center mb-12" data-id="element-96">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-97">
              ❓ PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-4" data-id="element-98">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-800 rounded-xl overflow-hidden bg-brand-dark" data-id="element-99">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-100">
                  <span className="font-bold text-lg text-white pr-8" data-id="element-101">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-light shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-102" />
                </button>
                <AnimatePresence data-id="element-103">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-104">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-gray-800/50 mt-2" data-id="element-105">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}